
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contract",
      function () {
        return require("private-next-pages/contract/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contract"])
      });
    }
  